import React, { useState, useEffect } from "react";
import { FaArrowTurnUp } from "react-icons/fa6";

function TopButton() {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
      setIsVisible(window.scrollY > 200);
    };
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  
    React.useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

  return (
    isVisible && (
    <button onClick={scrollToTop} id="backToTopBtn" class="btn_hover2">
        <FaArrowTurnUp style={{color: '#A326AA'}}/>
    </button>
    )
  )
}

export default TopButton
